export const CAROUSEL_CROP_WIDTH = 1600;
export const CAROUSEL_CROP_HEIGHT = 640;

const ORIGIN = "https://scavengertime.com";

export function rowsOf(data) {
  const result = data?.result;
  const list = Array.isArray(result?.data)
    ? result.data
    : Array.isArray(result)
      ? result
      : Array.isArray(data?.data)
        ? data.data
        : [];
  return list
    .map((row) => ({
      id: String(row?.id ?? ""),
      name: row?.group_name || row?.name || row?.title || `Item ${row?.id}`,
    }))
    .filter((row) => row.id && row.id !== "undefined");
}

export function carouselLinkFor(kind, { url = "", id = "" } = {}) {
  const itemId = String(id || "").trim();
  if (kind === "store") return `${ORIGIN}/store`;
  if (kind === "learn") return `${ORIGIN}/learn`;
  if (kind === "credits") return `${ORIGIN}/credits`;
  if (kind === "item" && itemId) return `${ORIGIN}/store/item/${itemId}`;
  if (kind === "quest" && itemId) return `${ORIGIN}/store/quest/${itemId}`;
  if (kind === "hunt" && itemId) return `${ORIGIN}/store/hunt/${itemId}`;
  if (kind === "web") return String(url || "").trim();
  return "";
}

export function carouselDestination(link) {
  const raw = String(link || "").trim();
  if (!raw) return { kind: "none", url: "", id: "" };
  let url;
  try {
    url = new URL(raw);
  } catch (_) {
    return { kind: "web", url: raw, id: "" };
  }
  const host = url.hostname.toLowerCase().replace(/^www\./, "");
  const own = host === "scavengertime.com" || host.endsWith(".scavengertime.com");
  if (!own) return { kind: "web", url: raw, id: "" };
  const parts = url.pathname.split("/").filter(Boolean);
  const a = (parts[0] || "").toLowerCase();
  const b = (parts[1] || "").toLowerCase();
  const c = parts[2] || "";
  if (a === "store" && parts.length === 1) return { kind: "store", url: raw, id: "" };
  if (a === "store" && b === "item" && c) return { kind: "item", url: raw, id: c };
  if (a === "store" && b === "quest" && c) return { kind: "quest", url: raw, id: c };
  if (a === "store" && b === "hunt" && c) return { kind: "hunt", url: raw, id: c };
  if (a === "store" && parts.length === 2 && /^\d+$/.test(b)) return { kind: "item", url: raw, id: b };
  if (a === "learn" || a === "tutorial" || a === "learning-center") return { kind: "learn", url: raw, id: "" };
  if (a === "credits" || a === "hunt-credits") return { kind: "credits", url: raw, id: "" };
  return { kind: "web", url: raw, id: "" };
}
